import React, { useEffect } from 'react';
import { useAnalytics, authService } from '@withjoy/web-core';
import { JoyHeader } from '@components/JoyHeader';
import { RouteComponentProps } from 'react-router';
import { Spinner } from '@components/Spinner';

export const AuthCallback: React.FC<{ history: RouteComponentProps<any>['history']; refetch: () => any }> = React.memo(
  ({ history, refetch }) => {
    const analytics = useAnalytics({
      category: 'Authenticate',
      page: 'callback',
      pagePrefix: 'marketing',
      deferPageTrack: true,
      referrerOverride: 'https://withjoy.com/callback'
    });

    useEffect(() => {
      analytics.page.pageEnter();
      analytics.track({ action: 'Authenticated' });
      authService.handleAuthentication(history, refetch);
    }, []);

    return (
      <div style={{ padding: '40px' }}>
        <JoyHeader />
        <Spinner style={{ top: '20%', height: '50%' }} />
      </div>
    );
  }
);
